import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { MultiSelect } from 'src/web/components/Input/DropdownsOld/MultiSelect/component';
import { ModalDialog } from 'src/web/components/Modals/ModalDialog';
import { useGetPortalGroupsApi } from '../../hooks';
import {
  GroupListItem,
  GroupList,
  GroupNameHeading,
  StyledTimesButton,
} from './styles';
import { ErrorMessage } from '../../styles';

interface AddToGroupProps {
  institutionPath: string;
  isAddingToGroupLoading: boolean;
  errorAddEnrolmentToGroups: string;
  onAddToGroup: (userGroups: string[]) => void;
  onHide: () => void;
}

export const AddToGroupModal: React.FC<AddToGroupProps> = ({
  institutionPath,
  isAddingToGroupLoading,
  errorAddEnrolmentToGroups,
  onAddToGroup,
  onHide,
}) => {
  const [selectedValues, setSelectedValues] = useState<
    Readonly<{ label: string; value: string }[]>
  >([]);
  const removeSelectedValues = (removedValue: string): void => {
    setSelectedValues((prev) =>
      prev.filter(({ value }) => value !== removedValue)
    );
  };
  const [groups] = useGetPortalGroupsApi(institutionPath);

  return (
    <>
      <ModalDialog
        show
        center
        small
        onHide={onHide}
        title="Add to groups"
        actions={[
          {
            label: 'Cancel',
            onClick: onHide,
            type: 'default',
          },
          {
            label: 'Add to groups',
            showSpinner: isAddingToGroupLoading,
            disabled: isAddingToGroupLoading,
            onClick: () =>
              onAddToGroup(selectedValues.map(({ value }) => value)),
            type: 'primary-kelp',
          },
        ]}
      >
        <MultiSelect
          placeholder="Choose groups..."
          controlShouldRenderValue={false}
          options={groups.map((group) => ({ label: group, value: group }))}
          value={selectedValues}
          onChange={(values) => setSelectedValues(values)}
        />
        {selectedValues.length > 0 && (
          <GroupList>
            <GroupNameHeading>Group name</GroupNameHeading>
            {selectedValues.map(({ label, value }) => (
              <GroupListItem>
                <span>{label}</span>
                <StyledTimesButton
                  type="button"
                  onClick={() => removeSelectedValues(value)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </StyledTimesButton>
              </GroupListItem>
            ))}
          </GroupList>
        )}
        <ErrorMessage>{errorAddEnrolmentToGroups}</ErrorMessage>
      </ModalDialog>
    </>
  );
};
